






























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DeleteSendCommand from "./deletesendcommand.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageSendCommandListRequest extends PageRequest {
  keyword: string;
  areaId: number;
  collectorId: string;
  meterId: string;
  commandType: number = 0;
  startTime: string;
  endTime: string;
}

@Component({
  components: { DeleteSendCommand },
})
export default class sendcommandlist extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //复制
  async del() {
    this.deleModalShow = true;
  }
  //filters
  pagerequest: PageSendCommandListRequest = new PageSendCommandListRequest();
  columnlist: any[] = [];
  collectorlist: any[] = [];
  meterlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  deleModalShow: boolean = false;
  splitnum: number = 0.15;

  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    } else {
      this.pagerequest.sorting = " sendTime desc ";
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.commandsendlist.list;
  }
  get loading() {
    return this.$store.state.commandsendlist.loading;
  }
  isActiveChange(val: number) {
    this.$store.commit("commandsendlist/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("commandsendlist/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("commandsendlist/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("commandsendlist/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "commandsendlist/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.commandsendlist.pageSize;
  }
  get totalCount() {
    return this.$store.state.commandsendlist.totalCount;
  }
  get currentPage() {
    return this.$store.state.commandsendlist.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Nothing"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Nothing")
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("MeterNo"),
      key: "meterNo",
      width: 150,
      fixed: "left",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("Collector"),
      key: "collectorId",
      width: 150,
      render: (h: any, params: any) => {
        let id = params.row.collectorId;
        let info = this.collectorlist.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].no : this.L("Nothing"));
      },
    },
    {
      sortable: true,
      title: this.L("Command") + this.L("Category"),
      key: "commandType",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.commandType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Nothing"));
      },
    },
    {
      sortable: true,
      title: this.L("Actions") + this.L("Users"),
      key: "userName",
      width: 130,
    },
    {
      sortable: true,
      title: this.L("Actions") + this.L("Time"),
      key: "sendTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.sendTime == null
            ? ""
            : Moment(params.row.sendTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("Command") + "Id",
      key: "commandId",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.commandId,
            },
          },
          params.row.commandId
        );
      },
    },
    {
      sortable: true,
      title: this.L("Platform") + "Id",
      key: "ispDeviceId",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.ispDeviceId,
            },
          },
          params.row.ispDeviceId
        );
      },
    },
    {
      sortable: true,
      title: this.L("Sending") + this.L("State"),
      key: "commandStatus",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.commandStatus,
            },
          },
          params.row.commandStatus
        );
      },
    },
    {
      sortable: true,
      title: this.L("Return") + this.L("Info"),
      key: "sendMsg",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.sendMsg,
            },
          },
          params.row.sendMsg
        );
      },
    },
    {
      sortable: true,
      title: this.L("Sending") + this.L("Time"),
      key: "sendingTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.sendingTime == null
            ? ""
            : Moment(params.row.sendingTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("Sending") + this.L("Result"),
      key: "sendResult",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.sendResult,
            },
          },
          params.row.sendResult
        );
      },
    },
    {
      sortable: true,
      title: this.L("Command"),
      key: "commandStr",
      width: 400,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.commandStr,
            },
          },
          params.row.commandStr
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 90,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('sendCommandListDel');
        return h("div", [
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "commandsendlist/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async getCollectorTree() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.collectorlist.push(ele);
          });
        }
      })
      .catch((err) => {
        //return null;
      });
  }
  //获取表列表
  async getMeterList() {
    await this.$store
      .dispatch("meter/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.meterlist.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async created() {
    this.pagerequest.sorting = " sendTime desc ";
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    await this.getCollectorTree();
    this.getMeterList();
    this.getItemDetail();
    this.getAreaTree();
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  // 时间触发
  changeTime(time) {
    this.pagerequest.startTime = Moment(time[0], "YYYY-MM-DD HH:mm:ss")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment(time[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
    //console.log(this.pagerequest)
  }
  data() {
    return {
      paramslist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 15;
      });
      info.forEach((ele) => {
        this.$data.paramslist.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
}
